/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ByocFactory, ByocFactoryInterface } from "../ByocFactory";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_twRegistry",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "deployer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "publisher",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "deployedContract",
        type: "address",
      },
    ],
    name: "ContractDeployed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "prevOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnerUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "isPaused",
        type: "bool",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_publisher",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_contractBytecode",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "_constructorArgs",
        type: "bytes",
      },
      {
        internalType: "bytes32",
        name: "_salt",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "string",
            name: "publishMetadataUri",
            type: "string",
          },
          {
            internalType: "string",
            name: "contractURI",
            type: "string",
          },
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
        ],
        internalType: "struct ThirdwebContract.ThirdwebInfo",
        name: "_thirdwebInfo",
        type: "tuple",
      },
    ],
    name: "deployInstance",
    outputs: [
      {
        internalType: "address",
        name: "deployedAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_publisher",
        type: "address",
      },
      {
        internalType: "address",
        name: "_implementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_initializeData",
        type: "bytes",
      },
      {
        internalType: "bytes32",
        name: "_salt",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "string",
            name: "publishMetadataUri",
            type: "string",
          },
          {
            internalType: "string",
            name: "contractURI",
            type: "string",
          },
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
        ],
        internalType: "struct ThirdwebContract.ThirdwebInfo",
        name: "_thirdwebInfo",
        type: "tuple",
      },
    ],
    name: "deployInstanceProxy",
    outputs: [
      {
        internalType: "address",
        name: "deployedAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getPublishMetadataUri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_pause",
        type: "bool",
      },
    ],
    name: "setPause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "publishMetadataUri",
            type: "string",
          },
          {
            internalType: "string",
            name: "contractURI",
            type: "string",
          },
          {
            internalType: "address",
            name: "owner",
            type: "address",
          },
        ],
        internalType: "struct ThirdwebContract.ThirdwebInfo",
        name: "_thirdwebInfo",
        type: "tuple",
      },
    ],
    name: "setThirdwebInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ByocFactoryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ByocFactoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ByocFactory__factory extends ContractFactory {
  constructor(...args: ByocFactoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _twRegistry: string,
    _trustedForwarder: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ByocFactory> {
    return super.deploy(
      _twRegistry,
      _trustedForwarder,
      overrides || {}
    ) as Promise<ByocFactory>;
  }
  override getDeployTransaction(
    _twRegistry: string,
    _trustedForwarder: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _twRegistry,
      _trustedForwarder,
      overrides || {}
    );
  }
  override attach(address: string): ByocFactory {
    return super.attach(address) as ByocFactory;
  }
  override connect(signer: Signer): ByocFactory__factory {
    return super.connect(signer) as ByocFactory__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ByocFactoryInterface {
    return new utils.Interface(_abi) as ByocFactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ByocFactory {
    return new Contract(address, _abi, signerOrProvider) as ByocFactory;
  }
}
